export default "/images/dcdc3235a260d369d0590e5e68dca690.avif";